module.exports = {
  "country": "BE",
  "artist": "Kate Ryan",
  "song": "Je t'adore",
  "year": "2006",
  "place": "NQ",
  "spotify": "1YuXoPqkTQOXpFJtjf5GWd"
};